import React from 'react';
import { Control } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl, FormDescription } from '@/components/ui/form';
import { InfoTooltip } from '../../ui/InfoTooltip';
import { MoneyInput } from '../../ui/MoneyInput';

interface DeductionsFieldsProps {
  control: Control<any>;
}

export function DeductionsFields({ control }: DeductionsFieldsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <FormField
        control={control}
        name="incomeTax"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-2">
              Income Tax (€/year)
              <InfoTooltip content="The total annual income tax you pay." />
            </FormLabel>
            <FormControl>
              <MoneyInput {...field} />
            </FormControl>
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="usc"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-2">
              Universal Social Charge (€/year)
              <InfoTooltip content="Your total annual USC payment." />
            </FormLabel>
            <FormControl>
              <MoneyInput {...field} />
            </FormControl>
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="prsi"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-2">
              PRSI (€/year)
              <InfoTooltip content="Your total annual PRSI contributions." />
            </FormLabel>
            <FormControl>
              <MoneyInput {...field} />
            </FormControl>
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="propertyTax"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-2">
              Property Tax (€/year)
              <InfoTooltip content="Annual Local Property Tax (LPT) payments." />
            </FormLabel>
            <FormControl>
              <MoneyInput {...field} />
            </FormControl>
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="homeLoanInterest"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-2">
              Home Loan Interest (€/year)
              <InfoTooltip content="Interest paid on loans secured against your primary residence." />
            </FormLabel>
            <FormControl>
              <MoneyInput {...field} />
            </FormControl>
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="maintenancePayments"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-2">
              Maintenance Payments (€/year)
              <InfoTooltip content="Court-ordered or legally required maintenance payments to dependents." />
            </FormLabel>
            <FormControl>
              <MoneyInput {...field} />
            </FormControl>
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="healthExpenses"
        render={({ field }) => (
          <FormItem className="md:col-span-2">
            <FormLabel className="flex items-center gap-2">
              Health Expenses (€/year)
              <InfoTooltip content="Medical expenses not reimbursed by health insurance or tax relief." />
            </FormLabel>
            <FormControl>
              <MoneyInput {...field} />
            </FormControl>
            <FormDescription>
              Health and medical expenses after any tax refunds or reimbursements.
            </FormDescription>
          </FormItem>
        )}
      />
    </div>
  );
}
